import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=54ec1f35&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=54ec1f35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54ec1f35"

export default script